import React, { Component } from 'react';
import { Link } from "react-router-dom";

class ProductTutorial extends Component{
    render(){
        const {mainBanner, themeLayoutId} = this.props
        return(
            <React.Fragment>

                {/* Beaty Theme */}

                {themeLayoutId === 'L03' && 
                <section className="video-section pt-0">
                <div className="container">
                    <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <Link to="">
                        <div className="video-img">
                        <video
                        className={"responsive-video"}
                        // preload={'false'}
                        autoPlay={true}
                        // loop={true}
                        muted={true}
                        playsInline={true}
                        controls={true}
                        // poster={""}
                        >
                        <source src={mainBanner[0].Video.APC_ELEMENT_CONTENT} />
                        </video>
                            
                        </div>
                        </Link>
                    </div>
                    </div>
                </div>
                </section>
                }

                {/* End Beauty Theme */}
                
            </React.Fragment>
        )
    }
}

export default ProductTutorial;
